export default __webpack_public_path__ + "assets/images/default-avatar.f5441841a712e14bdc310cdb0cf0b447.svg";